import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { ProductDesignTemplatePageModuleDataContent } from '../../../store/app.model';
import { buildPublicExperienceStyles } from '../../../services/global.service';
import { LineBreakPipe } from '../../../pipes/line-break.pipe';

@Component({
  selector: 'app-footer',
  imports: [CommonModule, ButtonModule, LineBreakPipe],
  templateUrl: './footer.component.html',
})
export class FooterComponent implements OnChanges {
  // @Input({ required: true }) content!: ProductDesignTemplatePageContent;
  @Input({ required: true }) content!: any;
  @Input({ required: true }) styles!: any;
  @Input({ required: true }) isSelectedModule!: boolean;
  @Input({ required: true }) isFirstModule!: boolean;
  @Input({ required: true }) isLastModule!: boolean;

  items: ProductDesignTemplatePageModuleDataContent[] = [];

  ngOnChanges(changes: SimpleChanges): void {
    if (this.content) {
      if (
        'pageModuleTemplateDataContents' in this.content &&
        Array.isArray(this.content.pageModuleTemplateDataContents)
      ) {
        this.items = this.content.pageModuleTemplateDataContents;
      } else if (
        'contentItems' in this.content &&
        Array.isArray(this.content.contentItems)
      ) {
        this.items = this.content.contentItems;
      } else if (
        'components' in this.content &&
        Array.isArray(this.content.components)
      ) {
        this.items = this.content.components;
      } else {
        this.items = [];
      }
    } else {
      this.items = [];
    }
  }

  buildStyle(type: string, style: any): string {
    return buildPublicExperienceStyles(type, style);
  }
}
